const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNetwork5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.521)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-45 96 166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 96,42  a 124,124 0 0 1 124,124 l 12,0 a 136,136 0 0 0 -136,-136 z",
    style: {
      fill: "green"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 96,66  a 100,100 0 0 1 100,100 l 12,0 a 112,112 0 0 0 -112,-112 z",
    style: {
      fill: "green"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 96,90   a 76,76 0 0 1 76,76  l 12,0 a 88,88 0 0 0 -88,-88 z",
    style: {
      fill: "green"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 96,114  a 52,52 0 0 1 52,52  l 12,0 a 64,64 0 0 0 -64,-64 z",
    style: {
      fill: "green"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 96,166 0,-40 a 40 40  0 0 1 40,40 z",
    style: {
      fill: "green"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNetwork5);
export default __webpack_public_path__ + "static/media/icon-network-5.cb834386715d03a0069a69f7c7550cc3.svg";
export { ForwardRef as ReactComponent };